import { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { East as EastIcon } from '@mui/icons-material';
import { subWeeks } from 'date-fns';

import { apiUrl } from '../../utilities/apiUrl';
import { sortByCheckInDate } from '../../utilities/sortBy';
import { DashboardTable } from '../Table/DashboardTable';
import { OutlinedButton } from '../index';

const style = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  py: 3,
  px: 5,
};

const iconStyle = {
  fill: '#84d8c5 !important',
  ml: '5px',
};

export const Timesheet = (props) => {
  const [empId] = useOutletContext();
  const [timesheets, setTimesheets] = useState([]);
  let navigate = useNavigate();

  useEffect(() => {
    fetch(
      apiUrl(
        `/timesheet?startdate=${subWeeks(new Date(), 2)}&enddate=${new Date()}&empid=${empId}`
      ),
      {
        method: 'GET',
        credentials: 'include',
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.data[data.data.length - 1]['checkout'] === null) {
          // Remove the timesheet with null check out
          data.data.splice(-1, 1);
        }
        let sortedTimesheetData = sortByCheckInDate(data.data).reverse();
        setTimesheets(sortedTimesheetData);
      });
  }, [empId, props.isActive]);

  const routeChange = () => {
    let path = '/timesheet';
    navigate(path);
  };

  return (
    <Box sx={style}>
      <Typography
        sx={{
          textAlign: 'center',
          fontWeight: '700',
          fontSize: '1.8rem',
          mb: 2,
        }}
        variant="h4"
        component="div"
      >
        TIMESHEET
      </Typography>
      {timesheets.length !== 0 ? (
        <DashboardTable data={timesheets.slice(-5)} />
      ) : (
        <Typography align="center" variant="subtitle1" sx={{ mt: 12 }}>
          No Data
        </Typography>
      )}
      <OutlinedButton
        style={timesheets.length !== 0 ? { mt: 2 } : { mt: 'auto' }}
        variant="outlined"
        endIcon={<EastIcon sx={iconStyle} />}
        onClick={routeChange}
        btnTitle="View All"
      />
    </Box>
  );
};
